// generation design sourceType
export enum SourceType {
  Manual = 'MANUAL',  // disable homer run
  Homer = 'HOMER' // enable homer run
}
